var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7957_2768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.875 18.125H13.125",
    stroke: "#1859B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14853 13.0468C5.40554 12.4663 4.80374 11.7251 4.38833 10.8787C3.97293 10.0324 3.75472 9.10285 3.7501 8.16004C3.73135 4.77254 6.4626 1.95301 9.84931 1.87488C11.1618 1.84309 12.451 2.22543 13.534 2.96765C14.6169 3.70986 15.4387 4.77427 15.8826 6.00984C16.3265 7.24541 16.37 8.5894 16.007 9.85111C15.644 11.1128 14.8929 12.2282 13.8603 13.0389C13.6325 13.2155 13.4479 13.4417 13.3205 13.7002C13.1932 13.9588 13.1263 14.2429 13.1251 14.5311V14.9999C13.1251 15.1656 13.0592 15.3246 12.942 15.4418C12.8248 15.559 12.6659 15.6249 12.5001 15.6249H7.5001C7.33434 15.6249 7.17536 15.559 7.05815 15.4418C6.94094 15.3246 6.8751 15.1656 6.8751 14.9999V14.5311C6.8748 14.2448 6.8092 13.9622 6.6833 13.705C6.5574 13.4478 6.37451 13.2227 6.14853 13.0468Z",
    fill: "#1859B4",
    fillOpacity: 0.1,
    stroke: "#1859B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 4.375C12.1875 4.63828 13.4852 5.9375 13.75 7.5",
    stroke: "#1859B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7957_2768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.84e6075c6238b76e5d547e306bcd1627.svg";
export { ForwardRef as ReactComponent };